import React from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";

function Revolutionindustries(props) {
  return (
    <section className="tekgrip_section tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={10} xl={10} xxl={10}>
            <div className="example" data-text="Comprehensive">
              <h2>
                Our Logistics Software Solutions to Optimize Operational
                Efficiencies
              </h2>
            </div>
            <p className="main_para">
              We offer feature-rich logistics software that improves operations,
              lowers expenses, and meets your demands. Our solutions help you
              digitize your way out of inefficiencies and streamline your daily
              tasks including:
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Tab.Container defaultActiveKey="0">
              <Row>
                <Col xs={12} md={6} lg={6} xl={6}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="0">Warehouse Management</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="1">Route Optimization</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="2">Order Management</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="3">Parcel Tracking & Audit</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="4">Demand Forecasting</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                  <Tab.Content>
                    <Tab.Pane eventKey="0">
                      <p>
                        As a dedicated logistic software development company, we
                        integrate smart logistic solutions to automate
                        warehousing with inventory scanning and organizing
                        capabilities. It helps businesses administer quality
                        control on the inventory and stock for large warehouses
                        without manual testing or human oversight.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="1">
                      <p>
                        Our logistic software development services help
                        businesses utilize artificial intelligence and machine
                        learning to determine the accurate delivery time for
                        shipments. Vendors can use their previous trips or
                        integrate historical trip sheets from other sources to
                        create better estimates and optimize delivery routes
                        using AI.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="2">
                      <p>
                        Our logistic software solutions include built-in
                        accounting information systems (AIS) and smart business
                        intelligence apps to facilitate businesses to keep track
                        of their orders. Being a premier custom logistic
                        software development company, we also support
                        integrations with popular AIS software like Sage & SAP
                        to allow businesses to connect with their existing
                        databases on the go.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="3">
                      <p>
                        As a reputable custom logistics software development
                        company, we streamline your order-handling process with
                        our scalable order management software, which helps you
                        fulfill orders more quickly, provide better customer
                        service, & increase profit margins. Businesses can also
                        perform parcel audits to learn about the estimated
                        delivery time for each parcel, & track parcels until
                        delivered.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="4">
                      <p>
                        Our Fintech software apps provide peer-to-peer
                        transaction capabilities that allow end users to
                        transfer money securely. With P2P money transfer
                        services, users can send and receive money directly to
                        the other user's account or wallet without involving
                        intermediaries such as banks and digital wallets.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Revolutionindustries;
